export enum ComponentServiceTypes {
  Retail = 'retail',
  Standard = 'standard'
}
